import ContactoBlock from '../../components/bodyBlocks/contactoBlock/ContactoBlock'
import '../../index.css'

function Contacto() {
  return (
    <div>
        <ContactoBlock/>
    </div>
   
  )
}

export default Contacto
